import Route from '@ember/routing/route';

export default class LibraryUsersIndexRoute extends Route {
  queryParams = {
    text: { replace: true, scope: 'controller' },
  };
}
